<template>
  <div class="about-index">
    <website-header :setNum="1"></website-header>
    <div class="index-top" :style="`background-image:url('${imgURI + '/static/about/qiyejiesaotoutu.png'}');`">
<!--      <div class="index-top-bor">-->
<!--        <div class="display-flex tips-c">侃侃 让世界更懂你！</div>-->
<!--        <div class="display-flex flex-column tips">-->
<!--          <div class="bold">MAKE THE WORLD</div>-->
<!--          <div class="font-weight-100">UNDERSTAND YOU BETTER</div>-->
<!--        </div>-->
<!--      </div>-->
    </div>
    <div class="earth-bg margin-center" :style="`background-image:url('${imgURI + '/static/about/ditubeijng.png'}');`">
      <div class="title-bor display-flex margin-center text-center">
        <div class="line"></div>
        <div class="font-30 color-666">ABOUT US</div>
        <div class="c font-20 color-87898A">关于我们</div>
      </div>
      <div class="data-bor">
        <img :src="`${imgURI}/static/index/suju.png`"/>
      </div>
    </div>
<!--    企业简介-->
    <div class="display-flex" id="profile">
      <div class="company-left">
        <div class="company-left-one">
          <tips :tipsC="`企业简介`" :tipsE="`COMPANY PROFILE`" :paddingTop="20"></tips>
          <div class="font-14 introduction-cont">
            公司成立于2011年，总部位于重庆，在深圳、广州等设有分公司及办事处。<br/>
            侃侃致力于为国内的跨境电商卖家提供一站式综合服务，为传统制造型企业出海提供<br/>
            落地的转型升级服务。
          </div>
          <div class="font-14 introduction-cont-2">
            与Google、Facebook等社交平台，Amazon、eBay、Wish、Shopee、Lazada等<br/>
            B2C电商平台，Shopify、Shopline等独立站平台密切合作，重点打造覆盖卖家、<br/>
            服务商、供应链和跨境平台的跨境电商生态圈。
          </div>
        </div>
      </div>
      <div class="company-right">
        <img :src="`${imgURI}/static/about/qiyetu.png`"/>
      </div>
    </div>
<!--    企业目标-->
    <div class="enterprise-bor display-flex justify-content-between" id="goals">
      <div class="enterprise-img">
        <img :src="`${imgURI}/static/about/mubiaotu.png`"/>
      </div>
      <div>
        <tips :tipsC="`企业目标`" :tipsE="`ENTERPRISE GOALS`" :paddingTop="20"></tips>
        <div class="enterprise-content font-14">
          <div class="enterprise-content-one">
            成为跨境出口电商行业内TOP的企业孵化、培训及服务平台。
          </div>
          <div class="enterprise-content-one">
            打造跨境出口电商行业内规模最大且不断追求价值实现的商业共同体。
          </div>
          <div>
            助力至少1000家国内传统制造型企业出海，帮助至少1000家亿级跨境电商企业实现<br/>
            跨越式发展。
          </div>
        </div>
      </div>
    </div>
<!--    moss的精神家园-->
    <div class="moss">
      <div style="width: 100%">
        <div class="display-flex">
          <div style="width: 47%"></div>
          <div class="title">Moss的精神家园</div>
        </div>
        <div class="moss-bor display-flex">
          <div style="width: 47%"></div>
          <ul class="moss-ul">
            <li>
              <span class="moss-tips-block"></span>
              侃侃&白鹿会创始人，畅销书作家
            </li>
            <li>
              <span class="moss-tips-block"></span>
              澳洲悉尼大学经济学硕士，跨境电商行业TOP级运营顾问
            </li>
            <li>
              <span class="moss-tips-block"></span>
              浙江大学中国跨境电子商务大讲堂专家讲师
            </li>
            <li>
              <span class="moss-tips-block"></span>
              连续多年荣获跨境电商行业最具人气奖、突出贡献奖等荣誉
            </li>
            <li>
              <span class="moss-tips-block"></span>
              代表著作:《跨境电商亚马逊是如何运营的--从零做到年销千万实操手册》
            </li>
          </ul>
        </div>
      </div>
      <div class="moss-img">
        <img class="user" :src="`${imgURI}/static/about/mosstouxiang.png`"/>
        <img class="book-one" :src="`${imgURI}/static/about/DOUYIN.png`"/>
        <img class="book-two" :src="`${imgURI}/static/about/SHU.png`"/>
      </div>
    </div>
    <div id="history" class="development" :style="`background-image:url('${imgURI + '/static/about/fazhanlichanbeijingtu.png'}');`">
      <div>
        <div class="website-index-tips text-center">
          <span class="tips-about bold color-FFFFFF">DEVELOPMENT HISTORY</span>
        </div>
        <div class="website-index-tips-c text-center color-FFFFFF">发展历程<span class="tips-block"></span></div>
      </div>
      <ul class="year-list">
        <li class="cursor-pointer" v-for="(item, index) in yearList" :key="index" @click="changeYear(index)">
          <div class="year">{{item.year}}</div>
          <div class="line" :class="{'is-line': year === index}"></div>
        </li>
      </ul>
      <div v-html="yearList[year].content" class="year-content display-flex justify-content-center"></div>
    </div>
    <website-bot></website-bot>
  </div>
</template>

<script>
import WebsiteBot from '@/components/public/websiteBot'
import WebsiteHeader from '@/components/public/header'
import tips from '@/components/public/tips'
import config from '@/config/index'

export default {
  components: {WebsiteBot, WebsiteHeader, tips},
  name: 'aboutIndex',
  data () {
    return {
      imgURI: config.imgURI,
      yearList: [
        {
          year: 2011,
          content: '于广州成立跨境电商公司，在速卖通、eBay等多个平台开展业务'
        },
        {
          year: 2014,
          content: '重点布局亚马逊平台，打造出多个爆款单品，创建国内最大的跨境电商论坛，单日UV破十万<br/>开展亚马逊培训40余场，培训跨境电商卖家2000余人次'
        },
        {
          year: 2016,
          content: '着力发展海外私域流量社群，积累海外私域粉丝超十万人，累计为超过800家跨境电商企业提供流量服务<br/>建立私域交流社群“小密圈”，同时为千位跨境电商卖家赋能'
        },
        {
          year: 2017,
          content: '“侃侃”品牌正式成立，并开设深圳公司，下辖三个跨境电商公众号粉丝数首年即突破50万<br/>“侃侃电商学院”新增四门专业课，年培训人次首次突破3000+'
        },
        {
          year: 2019,
          content: '全年连续召开10余场跨境电商千人峰会，先后举办广州美博会跨境专场、上海美博会跨境专场<br/>线上三大专题研究院成立，同时为超5000位卖家提供帮助'
        },
        {
          year: 2020,
          content: '全年组织开展跨境电商知识分享交流活动超100场，“侃侃大学”成立，开设八大专题课程，陪跑年度学员超1500人次<br/>持续为跨境电商企业提供资源型服务，累计服务企业超4000家'
        },
        {
          year: 2023,
          content: '侃侃新媒体全平台粉丝量破百万，全年累计开课超100场，培训跨境电商卖家超5000人次。线上直播跨境电商培训超60场，覆盖用户20W+<br/>全面升级“侃侃电商学院”，突破专题公开课模式，新增小班课、实操课、内训课、工作坊等'
        },
        {
          year: 2024,
          content: '未来可期'
        }
      ],
      year: 0
    }
  },
  mounted () {
    if (this.$route.query.id) {
      this.goAnchor(this.$route.query.id)
    }
    // this.setCrossBorder()
  },
  watch: {
    // 监听路由对象$route的变化
    '$route': {
      handler: function (to, from) {
        if (to) {
          this.goAnchor(to.query.id)
        }
      },
      deep: true
    }
  },
  beforeDestroy () {
  },
  methods: {
    goAnchor (id) {
      document.querySelector(`#${id}`).scrollIntoView({
        behavior: 'smooth'
      })
    },
    changeYear (index) {
      this.year = index
    }
  }
}
</script>

<style lang="scss" scoped>
.about-index{
  .index-top{
    margin-top: -100px;
    width: 100%;
    height: 750px;
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center;
    .index-top-bor{
      padding-top: 180px;
      margin: 0 auto;
      width: 1200px;
    }
    .tips{
      font-size: 25px;
      color: #ffffff;
    }
    .tips-c{
      letter-spacing: 8px;
      font-size: 48px;
      font-weight: bold;
      color: #ffffff;
    }
  }
  .earth-bg{
    margin-top: 60px;
    width: 1200px;
    height: 427px;
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center;
    .title-bor{
      flex-direction: column;
      width: 154px;
      .line{
        margin: 36px auto 0 auto;
        width: 36px;
        height: 2px;
        background: #2095EB;
      }
      .c{
        position: relative;
        top: -6px;
      }
    }
    .data-bor{
      margin: 50px auto 0 auto;
      width: 1220px;
      height: 114px;
      img{
        width: 100%;
        height: 100%;
      }
    }
  }
  .website-index-tips{
    padding: 89px 0 0 0;
  }
  .website-index-tips-c{
    padding-bottom: 60px;
    font-size: 24px;
  }
  .tips-about{
    letter-spacing: 2px;
    font-size: 25px;
  }
  .tips-block{
    position: relative;
    top: 2px;
    margin-left: 6px;
    display: inline-block;
    width: 12px;
    height: 12px;
    background: #0685D9;
    border-radius: 2px 2px 2px 2px;
  }

  .company-left{
    background: #FBFCFE;
    width: 50%;

    .company-left-one{
      width: 600px;
      float: right;
    }
    .introduction-cont{
      color: #979797;
      margin-top: 30px;
      line-height: 24px;
    }
    .introduction-cont-2{
      color: #979797;
      margin-top: 16px;
    }
  }
  .company-right{
    width: 50%;
    img{
      width: 100%;
    }
  }
  .enterprise-bor{
    width: 1200px;
    margin: 60px auto 0 auto;
    .enterprise-img{
      width: 428px;
      img{
        width: 100%;
      }
    }
    .enterprise-content{
      margin-right: 94px;
      color: #646464;
      .enterprise-content-one{
        margin-bottom: 6px;
      }
    }
    .enterprise-content .enterprise-content-one:nth-of-type(1){
      margin-top: 22px;
    }
  }
  .moss{
    margin-top: 300px;
    .title{
      color: #292C2E;
      font-size: 24px;
    }
    .moss-bor{
      background: #FBFBFD;
    }
    .moss-ul{
      font-size: 18px;
      color: #646464;
      li{
        padding: 6px 0;
      }
      .moss-tips-block{
        position: relative;
        top: -3px;
        margin-right: 4px;
        display: inline-block;
        width: 8px;
        height: 8px;
        background: #0685D9;
        border-radius: 2px 2px 2px 2px;
      }
    }
    .moss-img{
      width: 1200px;
      margin: -350px auto 0 auto;
      .user{
        width: 446px;
      }
      .book-one{
        margin-left: -140px;
        width: 83px;
      }
      .book-two{
        position: relative;
        top: 16px;
        left: 6px;
        width: 96px;
      }
    }
  }
  .development{
    margin: 100px 0 150px 0;
    width: 100%;
    height: 630px;
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center;
    .year-list{
      display: flex;
      justify-content: center;
      gap: 50px;
      li {
        display: flex;
        justify-content: center;
        flex-direction: column;
        align-items: center;
      }
      .year{
        font-size: 18px;
        color: #FFFFFF;
      }
      .line{
        margin-top: 4px;
        border: 1px solid #FFFFFF;
        border-radius: 50%;
        width: 15px;
        height: 15px;
      }
      .is-line{
        background: #FFFFFF;
      }
    }
    .year-content{
      margin-top: 100px;
      font-size: 14px;
      color: #FFFFFF;
      text-align: center;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/about/index.vue